import React from 'react';
import { parse } from 'qs';
import { connect } from 'react-redux';
import { Row, Navbar, Nav, NavItem } from 'react-bootstrap';
import { IndexLinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';

import history from '../../history';
import { updateField } from '../../actions/form';
import styles from '../../styles/variables.scss';
import logo from '../../assets/trdlogo.png';

// ESLint disabled due to the render function lacking 'this'
// Best bet is to leave this, it was the best solution for the time being
// Need that life cycle hook for componentDidMount
/* eslint-disable class-methods-use-this */
export class Header extends React.Component {
  componentDidMount() {
    const params = parse(location.search);
    if (params && params.driver) {
      this.props.updateField('ratingSelf', 'driverName', params.driver);
      history.push('/rating/self/track-type');
    }
  }

  render() {
    return (
      <React.Fragment>
        <Row id="page-header">
          <Navbar collapseOnSelect>
            <Navbar.Header>
              <Navbar.Brand>
                <div id="logo-container">
                  <Link to="/">
                    <img src={logo} />
                  </Link>
                </div>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav className="header-links" pullRight>
                <IndexLinkContainer to="/partners">
                  <NavItem>
                    Partners
                  </NavItem>
                </IndexLinkContainer>
                <IndexLinkContainer to="/news">
                  <NavItem>
                    News
                  </NavItem>
                </IndexLinkContainer>
                <li role="presentation">
                  <a target="_blank" href="https://trdhydra.toyota.com/driver-account/">Account</a>
                </li>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Row>

        <style jsx global>{`
          #page-header {
            width: 100%;
            margin: 0;
          }

          .navbar-default {
            background-color: ${styles.darkerGrey};
            border: none;
            padding: 0 25px;
          }

          #logo-container {
            height: auto;
          }

          img {
            height: 50px;
          }

          .header-links {
            padding-top: 15px;

            a {
              font-size: 1.25em;
              font-weight: 700;
              text-decoration: none;
              text-transform: uppercase;
              border: none;

            }

            .active a {
              color: ${styles.trdRed} !important;
              background: none !important;
            }
          }
        `}</style>
      </React.Fragment>
    );
  }
}
/* eslint-enable */
export default connect(
  null,
  { updateField },
  null,
  { pure: false },
)(Header);
